var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAscSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon sort 01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.349.47a1 1 0 0 1 1.7 0l3.2 5.113a1 1 0 0 1-.848 1.53H1a1 1 0 0 1-.848-1.53z",
    transform: "rotate(180 8 5.557)",
    style: {
      fill: "#414b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.751.913a1 1 0 0 1 1.7 0l3.2 5.113a1 1 0 0 1-.848 1.53H1.4a1 1 0 0 1-.848-1.53z",
    transform: "translate(-.401 4.443)",
    style: {
      fill: "#8b95a5"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscSortIcon);
export default __webpack_public_path__ + "static/media/asc-sort-icon.55f909862ad093c7d2990fe520932524.svg";
export { ForwardRef as ReactComponent };